export const vwapDefaultInputs = {
  source: 'close', // index 0
  movingAverageCrossStrategy: true, // index 1
  movingAverageBasisType: 'sma', // index 2
  movingAverageSignalType: 'sma', // index 3
  movingAverageRatio: 1.08, // index 4
  movingAverageMultiplier: 89, // index 5
} as const;
